import React from 'react';

import SPBreadcrumb from 'components/base/SPBreadcrumb';
import SPSearchForm from 'components/product-price/cancel-rule-template/search-form';
import SPTable from 'components/product-price/cancel-rule-template/table';
import SPDrawer from 'components/product-price/cancel-rule-template/drawer';
import SPPageActionBar from "../../../components/product-price/cancel-rule-template/page-action-bar";
import SPModal from "../../../components/product-price/cancel-rule-template/modal";
import SPContentWrap from "../../../components/carRental/base/SPContentWrap";

interface IPageProps {
    enums?: any;
    permission?: any;
}

const SPPage: React.FC<IPageProps> = props => {
    const { enums, permission } = props;
  return (
    <>
      <SPBreadcrumb title="取消规则模板" />
        <SPContentWrap className='common-margin-top'>
            <SPSearchForm enums={enums} />
        </SPContentWrap>
        <SPContentWrap className='page-action-bar'>
            <SPPageActionBar permission={permission}></SPPageActionBar>
        </SPContentWrap>
      <SPTable permission={permission} enums={enums}/>
      <SPDrawer enums={enums}/>
      <SPModal></SPModal>
    </>
  );
};

export default SPPage;
